// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"e4dac2ec","429":"f250fcd1","481":"b3271265","486":"fac09c6f","739":"e4dac2ec","938":"89e3d6f4","978":"b3271265"}[chunkId] + ".chunk.css";
};